import { useState } from 'react'
import { useOnboarding } from '../../context/OnboardingContext'
import api from '../../lib/api'
import './WelcomeModal.css'

const PERSONAS = [
  'Founder / CEO', 'Sales / BD lead', 'Marketing lead',
  'Recruiter', 'Agency owner', 'Other',
]

export default function WelcomeModal() {
  const { state, visible, patch } = useOnboarding()
  const [url, setUrl] = useState('')
  const [persona, setPersona] = useState(PERSONAS[0])
  const [busy, setBusy] = useState(false)

  if (!visible || state.welcome_shown) return null

  const submit = async (skip) => {
    setBusy(true)
    const payload = { welcome_shown: true }
    if (!skip) {
      if (url) payload.prefetch_url = url
      if (persona) payload.persona = persona
      if (url) {
        api.post('/ai/scrape-website', { url }).catch(() => {})
      }
    }
    await patch(payload)
    setBusy(false)
  }

  return (
    <div className="onb-welcome-backdrop">
      <div className="onb-welcome">
        <h2>Welcome to SynxReach</h2>
        <p className="onb-welcome-sub">5 quick steps to start sending. Want to tell us a bit about you first?</p>

        <label className="onb-welcome-label">Your company website</label>
        <input
          className="onb-welcome-input"
          placeholder="https://acme.com"
          value={url}
          onChange={e => setUrl(e.target.value)}
        />

        <label className="onb-welcome-label">Who are you?</label>
        <select className="onb-welcome-input" value={persona} onChange={e => setPersona(e.target.value)}>
          {PERSONAS.map(p => <option key={p} value={p}>{p}</option>)}
        </select>

        <div className="onb-welcome-actions">
          <button className="onb-welcome-skip" disabled={busy} onClick={() => submit(true)}>Skip</button>
          <button className="onb-welcome-go"   disabled={busy} onClick={() => submit(false)}>Let's go</button>
        </div>
      </div>
    </div>
  )
}
